import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/activity`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchActivity = async ({ entity, entityId }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${entity}/${entityId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchActivitiesByMonth = async ({ entity, params }) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params[0]);

  let res = await fetch(readUrl(`${entity}?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const addActivity = async ({ entity, entityId, comment }) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${entity}/${entityId}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ comment }),
  });

  res = await parseJSON(res);

  return res.success;
};
